import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ChatbotState } from "./types";
import {
  botMigrationToStorageObjectAction,
  getBotChatsAction,
  getBotMessagesAction,
  updateChatbotAssistantAction,
} from "./actions";

export function botMigrationToStorageObjectReducerBuilder(
  builder: ActionReducerMapBuilder<ChatbotState>,
) {
  builder.addCase(botMigrationToStorageObjectAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(botMigrationToStorageObjectAction.fulfilled, (state) => {
    state.isLoading = false;
  });
  builder.addCase(botMigrationToStorageObjectAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function getBotChatsReducerBuilder(
  builder: ActionReducerMapBuilder<ChatbotState>,
) {
  builder.addCase(getBotChatsAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getBotChatsAction.fulfilled, (state, action) => {
    const { chats, ref } = action.payload;
    state.chats[ref] = [...chats.chats];
    state.isLoading = false;
  });
  builder.addCase(getBotChatsAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function updateChatbotAssistantReducerBuilder(
  builder: ActionReducerMapBuilder<ChatbotState>,
) {
  builder.addCase(updateChatbotAssistantAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(updateChatbotAssistantAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    const { updatedChats, ref } = action.payload;
    state.chats[ref] = [...updatedChats];
    state.isLoading = false;
  });
  builder.addCase(updateChatbotAssistantAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function getBotMessagesReducerBuilder(
  builder: ActionReducerMapBuilder<ChatbotState>,
) {
  builder.addCase(getBotMessagesAction.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(getBotMessagesAction.fulfilled, (state, action) => {
    state.messages = action.payload;
    state.isMessageLoading = false;
  });
  builder.addCase(getBotMessagesAction.rejected, (state) => {
    state.isMessageLoading = false;
  });
}
